import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8.81 24.473 6.62 20.75l-4.347-.888.49-4.21L0 12.44l2.764-3.18-.49-4.21 4.347-.888L8.81.41l3.858 1.776L16.524.41l2.217 3.753 4.318.888-.49 4.21 2.764 3.18-2.763 3.21.49 4.21-4.32.888-2.216 3.724-3.857-1.776zm.776-2.263 3.08-1.289 3.167 1.29 1.93-2.865 3.367-.86-.345-3.409 2.332-2.635-2.332-2.693.345-3.409-3.368-.802-1.986-2.865-3.11 1.29L9.5 2.672 7.571 5.538l-3.368.802.345 3.409-2.331 2.693 2.331 2.635-.345 3.466 3.368.803zm1.843-5.958 6.535-6.446-1.296-1.174-5.24 5.156-2.734-2.836-1.324 1.29z" }, null, -1)
  ])))
}
export default { render: render }